import axios from '../axios/axios-auth'

export default class AnomaliasService {

    getAnomaliasByOrgV3(orgId, params) {
        return axios.get(`/anomalies-service/v1/organizations/${orgId}/anomalies`, {params: params}).then(response => response.data)
    }

    getDatesWithDataV3(orgId) {
        return axios.get(`/anomalies-service/v1/organizations/${orgId}/anomalies/dates`).then(response => response.data)
    }


}
